__turbopack_context__.v({
  "companyTagline": "footer-module__FU_zXG__companyTagline",
  "disclaimerItem": "footer-module__FU_zXG__disclaimerItem",
  "errorMessage": "footer-module__FU_zXG__errorMessage",
  "firstFooterHeader": "footer-module__FU_zXG__firstFooterHeader",
  "footer": "footer-module__FU_zXG__footer",
  "footerContent": "footer-module__FU_zXG__footerContent",
  "footerDisclaimer": "footer-module__FU_zXG__footerDisclaimer",
  "footerLogo": "footer-module__FU_zXG__footerLogo",
  "footerMain": "footer-module__FU_zXG__footerMain",
  "footerWave": "footer-module__FU_zXG__footerWave",
  "footerWaveBackground__absoluteWhite": "footer-module__FU_zXG__footerWaveBackground__absoluteWhite",
  "footerWaveBackground__darkBlue": "footer-module__FU_zXG__footerWaveBackground__darkBlue",
  "footerWaveBackground__teal": "footer-module__FU_zXG__footerWaveBackground__teal",
  "footerWaveBackground__white": "footer-module__FU_zXG__footerWaveBackground__white",
  "footerWaveDesktop": "footer-module__FU_zXG__footerWaveDesktop",
  "footerWaveMobile": "footer-module__FU_zXG__footerWaveMobile",
  "formSignUp": "footer-module__FU_zXG__formSignUp",
  "fundraising": "footer-module__FU_zXG__fundraising",
  "gamcare": "footer-module__FU_zXG__gamcare",
  "inputSignUp": "footer-module__FU_zXG__inputSignUp",
  "linksColumn": "footer-module__FU_zXG__linksColumn",
  "linksHeader": "footer-module__FU_zXG__linksHeader",
  "logos": "footer-module__FU_zXG__logos",
  "paymentLogos": "footer-module__FU_zXG__paymentLogos",
  "plus18": "footer-module__FU_zXG__plus18",
  "registered": "footer-module__FU_zXG__registered",
  "regulatorLogos": "footer-module__FU_zXG__regulatorLogos",
  "signUpDescription": "footer-module__FU_zXG__signUpDescription",
  "signUpEmphasis": "footer-module__FU_zXG__signUpEmphasis",
  "signUpHeader": "footer-module__FU_zXG__signUpHeader",
  "signUpTitle": "footer-module__FU_zXG__signUpTitle",
  "socialLink": "footer-module__FU_zXG__socialLink",
  "socialLinks": "footer-module__FU_zXG__socialLinks",
  "spacedItems": "footer-module__FU_zXG__spacedItems",
  "trustpilot": "footer-module__FU_zXG__trustpilot",
});
